export enum ModalId {
  InviteEmployersAdminsByCVAdmin = 1,
  InvitePeoByCVStaffModal,
  InvitePeoPayrollProviderByCVStaffModal,
  InviteEmployersAdminsByPeoStaff,
  InviteEmployersUnderPeo,
  InviteEmployersByPeoPp,
  InvitePeoByPeoPp,
  InviteVerifiersAdminsByCVAdmin,
  InviteVerifiersStaffByCVAdmin,
  InviteVerifiersAdminsByVerifierAdmin,
  EmployerStaffDetailsModal,
  PeoPayrollProviderStaffDetailsModal,
  PeoPayrollProviderInviteStaffModal,
  ClearVerifyStaffDetailModal,
  ClearVerifyStaffInviteModal,
  InviteVerifierStaffByVerifierAdmin,
  VerifierStaffDetailsModal,
  VerifierStaffViewDetailsByVerifierAdmin,
  UserEmailConfirmRequestFulfilled,
  UserEmailConfirmRequestErrorModal,
  EmployeeUserItemInfoModal,
  EmployerAdminInviteStaffModal,
  UserChangePasswordModal,
  UserCreatePasswordChangeRequestModal,
  VerifierVerifyManuallyByCVStaffModal,
  VerifierVerifyAutomaticByCVStaffModal,
  EntityActionConfirmation,
  CreateDataDisputeOnEmployeeSignupByInvite,
  CreateDataDisputeOnEmployeeSignup,
  VerificationRequestCreateByCommercialVerifier,
  VerificationRequestCreateByGovernmentVerifier,
  VerificationRequestCreateByCVStaff,
  PermissiblePurposeCreateModal,
  PermissiblePurposeDeclineModal,
  CreateDataDisputeModal,
  ViewVerificationRequestReportModal,
  PositionDetails,
  VerifierBillingRulesChangeModal,
  EmployerBillingRulesChangeModal,
  ReverificationSubmitByVerifierStaff,
  UndergoReverificationConfirmationModal,
  VerifierCredentialStatusNoticeModal,
  StripeAddPaymentMethodModal,
  GetInTouchModal,
  VerifierAdminAddPaymentMethodModal,
  VerificationRequestPaymentTryAgainModal,
  UnfreezeYourAccountModal,
  PasswordResetConfirm,
  EmailChangeConfirm,
  DisclaimerEdit,
  DisclaimerDetails,
  DisclaimerDelete,
  FeinDetailsModal,
  FeinCreateModal,
  FeinEditModal,
  FeinDeleteModal,
  FeinCreateSignupModal,
  FeinEditSignupModal,
  FeinDeleteSignupModal,
  LocationDetailsModal,
  LocationCreateModal,
  LocationEditModal,
  LocationDeleteModal,
  LocationCreateSignupModal,
  LocationEditSignupModal,
  LocationDeleteSignupModal,
  GetWorkLetter,
  ConsumerManageAccountActivityModal,
  ConsumerDeleteDataModal,
  ConsumerRequestDataIsDeletedModal,
  InvitePeoStaffByPeoAdminModal,
  InvitePeoStaffByCVStaffModal,
  InvitePeoStaffByPeoPayrollProviderModal,
  PeoStaffViewDetails,
  CreateDataDisputeForPosition,
  TestVerificationRequestCreateModal,
  TestVerificationRequestPdfPreviewModal,
  DeleteVerifierConfirmationModal,
  DeleteVerifierStaffConfirmationModal,
  DeleteClearVerifyStaffConfirmationModal,
  MfaManagement,
  DashboardYTDFinancialReport,
  ApproveVerificationRequestByEmployee,
  ApproveVerificationRequestByVerifier,
  DeclineVerificationRequestByEmployee,
  DeclineVerificationRequestByVerifier,
  ResendInvite,
  RevenueShareReportGenerating,
  ResubscribeEmail,
  InvitePartnershipByPlatformStaff,
  EmployerControlledByConfiguration,
  PeoControlledByConfiguration,
  CreateIntegrationModal,
  ManageIntegrationModal,
  ViewApiVerificationRequestReportModal,
  ExportIntegrationUsageLogsModal,
  SendEmployeeInvite,
  VerifierInviteResent,
  EmployeeChangeEmail,
  DeleteEmployerStaffConfirmationModal,
  DeletePeoStaffConfirmationModal,
  DeleteEmployeeUserConfirmationModal,
}
